import $http from "../../helpers/api";

const state = {
  token: localStorage.getItem("access_token") || "",
  isAdmin: false,
  status: "",
  userId: null,
  username: "",
  tenant: {},
  roles: false,
  asf: [],
  currentAsf: null,
  isCanon: false,
  pending2fa: {
    challenge_token: null,
    email: null,
    password: null
  }
};

const getters = {
  getIsAdmin: state => state.isAdmin,
  getIsCanon: state => state.isCanon,
  isLoggedIn: state => state.token !== "",
  authStatus: state => state.status,
  getToken: state => state.token,
  getSessionRoles: state => state.roles,
  getAsf: state => state.asf,
  getCurrentAsf: state => state.currentAsf,
  getUserId: state => state.userId,
  getUsername: state => state.username,
  getTenant: state => state.tenant,
  getTenantLabel: state =>
    state.tenant && state.tenant.label ? state.tenant.label : "",
  getPending2fa: state => state.pending2fa,
  isInRoles: state => role => {
    if (!state.roles || !Array.isArray(state.roles)) {
      return false;
    }
    var bol = false;
    if (role.includes(",")) {
      role.split(",").forEach(function(element) {
        var trimmed = element.trim();
        if (trimmed && state.roles.indexOf(trimmed) !== -1) {
          bol = true;
        }
      });
    } else {
      var single = role.trim();
      if (single && state.roles.indexOf(single) !== -1) {
        bol = true;
      }
    }
    return bol;
  }
};

const actions = {
  auth_request({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      $http
        .post("/login", {
          email: data.email,
          password: data.password
        })
        .then(resp => {
          if (resp.data.requires_2fa) {
            commit("set_pending_2fa", {
              challenge_token: resp.data.challenge_token,
              email: data.email,
              password: data.password
            });
            const error = new Error("2FA required");
            error.requires2fa = true;
            reject(error);
            return;
          }

          const token = resp.data.access_token;

          localStorage.setItem("access_token", token);
          commit("auth_success", token);
          commit("session_user", resp.data.user);
          resolve(resp);
        })
        .catch(err => {
          if (err.requires2fa) {
            reject(err);
            return;
          }
          commit("auth_error", err);
          localStorage.removeItem("access_token");
          reject(err);
        });
    });
  },
  auth_verify_2fa({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("/login/2fa/verify", {
          challenge_token: data.challenge_token,
          code: data.code,
          email: data.email,
          password: data.password
        })
        .then(resp => {
          const token = resp.data.access_token;

          localStorage.setItem("access_token", token);
          commit("auth_success", token);
          commit("session_user", resp.data.user);
          commit("clear_pending_2fa");
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  auth_resend_2fa({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("/login/2fa/resend", {
          challenge_token: data.challenge_token
        })
        .then(resp => {
          commit("set_pending_2fa", {
            challenge_token: resp.data.challenge_token,
            email: state.pending2fa.email,
            password: state.pending2fa.password
          });
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  auth_cancel_2fa({ commit }) {
    commit("clear_pending_2fa");
  },
  auth_refresh({ commit, state }) {
    const previousToken = state.token;
    return $http.post("/login/refresh").then(response => {
      const token = response.data.access_token;
      if (!token || !state.token || state.token !== previousToken) {
        throw new Error("Session changed while refreshing authentication");
      }
      localStorage.setItem("access_token", token);
      commit("auth_success", token);
      return response;
    });
  },
  auth_logout({ commit }) {
    return new Promise(resolve => {
      commit("auth_logout");
      localStorage.removeItem("access_token");
      resolve();
    });
  },
  getSessionUser({ commit }) {
    return $http.get("/users/me").then(response => {
      commit("session_user", response.data.user);
    });
  }
};

const mutations = {
  setCurrentAsf(state, asf) {
    state.currentAsf = asf;
  },
  set_pending_2fa(state, pending2fa) {
    state.pending2fa = pending2fa;
  },
  clear_pending_2fa(state) {
    state.pending2fa = {
      challenge_token: null,
      email: null,
      password: null
    };
  },
  auth_request(state) {
    state.status = "loading";
  },
  auth_success(state, token) {
    state.status = "success";
    state.token = token;
  },
  auth_error(state) {
    state.status = "error";
  },
  auth_logout(state) {
    state.status = "";
    state.token = "";
    state.userId = null;
    state.username = "";
    state.tenant = {};
    state.roles = false;
    state.pending2fa = {
      challenge_token: null,
      email: null,
      password: null
    };
  },
  session_user(state, user) {
    state.userId = user.id;
    state.username = user.name;
    state.tenant = user.tenant || {};
    state.roles = (user.roles || []).map(role => role.name);
    const primaryAsf = (user.asfs || [])[0] || null;
    state.asf = primaryAsf;
    state.currentAsf = state.roles.includes("admin") ? null : (primaryAsf ? primaryAsf.id : null);
    state.isCanon = Boolean(primaryAsf && primaryAsf.super_asf);
    let roles = state.roles.filter(role => {
      return role === "admin";
    });
    state.isAdmin = roles.length > 0 && state.isCanon;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
